import React, { Fragment } from "react";
import Navbar2 from "../../components/Navbar2";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import { useLanguageChange } from "../../hooks/useLanguageChange";
import MetaTags from "../../components/MetaTags/MetaTags";

const TermsOfServicePageES = () => {
  useLanguageChange({
    currentLanguage: "es",
    redirectTo: "/en/terms-of-service",
  });
  const metaTagsProps = {
    title: "Términos de Servicio | Kesil Digital",
    description:
      "Condiciones de uso de la aplicación de Kesil Digital para el envío de correos mediante su cuenta de Google. Responsabilidades, acceso a datos y contacto.",
    url: "/es/terminos-y-condiciones",
  };
  return (
    <Fragment>
      <MetaTags {...metaTagsProps} />
      <Navbar2 alwaysFixed />
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <h2>Términos de Servicio</h2>
            <br />
            <br />
            <p>
              Al utilizar esta aplicación, usted acepta los siguientes términos:
            </p>

            <h5 style={{ marginTop: "10px" }}>1. Descripción del servicio</h5>
            <p>
              Kesil Digital ofrece servicios de desarrollo de software y
              automatización de procesos, incluyendo el envío de correos
              electrónicos en nombre del usuario mediante integraciones con
              plataformas como Google, así como otras herramientas digitales.
            </p>

            <h5 style={{ marginTop: "10px" }}>2. Uso del servicio</h5>
            <p>
              El usuario se compromete a utilizar el servicio de forma legal y
              responsable. Está prohibido el uso de la plataforma para el envío
              de spam, contenido ilegal o cualquier actividad que vulnere
              derechos de terceros o normativas aplicables.
            </p>

            <h5 style={{ marginTop: "10px" }}>3. Integración con Gmail</h5>
            <p>
              En caso de que el usuario autorice el acceso a su cuenta de Gmail,
              este acceso se utilizará exclusivamente para el envío de correos
              electrónicos en su nombre, de acuerdo con la configuración
              establecida.
            </p>
            <p>
              No accedemos, leemos, almacenamos ni analizamos el contenido de
              los correos electrónicos del usuario para ningún otro propósito
              distinto a la prestación del servicio.
            </p>
            <p>
              El usuario puede revocar este acceso en cualquier momento desde la
              configuración de su cuenta de Google.
            </p>

            <h5 style={{ marginTop: "10px" }}>
              4. Responsabilidad del usuario
            </h5>
            <p>
              El usuario es el único responsable del contenido de los correos
              enviados a través de la plataforma. Kesil Digital no se hace
              responsable del uso indebido del servicio ni de las consecuencias
              derivadas del mismo.
            </p>

            <h5 style={{ marginTop: "10px" }}>
              5. Limitación de responsabilidad
            </h5>
            <p>
              Kesil Digital no garantiza la disponibilidad continua del servicio
              y no será responsable por interrupciones, fallos técnicos, pérdida
              de datos o cualquier daño derivado del uso o imposibilidad de uso
              del servicio.
            </p>

            <h5 style={{ marginTop: "10px" }}>6. Servicios de terceros</h5>
            <p>
              Nuestros servicios pueden depender de plataformas externas como
              Google u otros proveedores. Kesil Digital no se responsabiliza por
              fallos, cambios o interrupciones en dichos servicios.
            </p>

            <h5 style={{ marginTop: "10px" }}>7. Protección de datos</h5>
            <p>
              El tratamiento de datos personales se rige por nuestra Política de
              Privacidad, disponible en nuestro sitio web.
            </p>

            <h5 style={{ marginTop: "10px" }}>8. Terminación del servicio</h5>
            <p>
              Nos reservamos el derecho de suspender o cancelar el acceso al
              servicio en caso de incumplimiento de estos términos o uso
              indebido de la plataforma.
            </p>

            <h5 style={{ marginTop: "10px" }}>9. Modificaciones</h5>
            <p>
              Kesil Digital podrá modificar estos términos en cualquier momento.
              Los cambios serán publicados en el sitio web y entrarán en vigor
              desde su publicación.
            </p>

            <h5 style={{ marginTop: "10px" }}>10. Contacto</h5>
            <p>
              Para cualquier consulta, puede contactarnos en
              contacto@kesildigital.com
            </p>
          </div>
        </div>
        <section className="wpo-contact-map-section">
          <div className="wpo-contact-map"></div>
        </section>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default TermsOfServicePageES;
